import './index.css';
import { jsx } from 'react/jsx-runtime';
import classnames from 'classnames';
import { CheckableCardElement } from '@hh.ru/magritte-ui-checkable-card/CheckableCardElement';
import { Action } from './Action.js';
import { TreeSelectorItemBase } from './TreeSelectorItemBase.js';
import 'react';
import '@hh.ru/magritte-ui-checkbox-radio';
import '@hh.ru/magritte-ui-cell';

const MobileItem = ({ item, isSelected, singleChoice, isSelectable, isDisabled, onChange, isSearch, parentId, renderItem = TreeSelectorItemBase, }) => {
    const input = isSelectable ? (jsx(Action, { selected: isSelected, onChange: onChange, id: item.id, singleChoice: singleChoice })) : undefined;
    return (jsx(CheckableCardElement, { padding: 16, borderRadius: 12, Element: "label", flexible: true, checked: isSelected, "data-qa": classnames('tree-selector-item', `tree-selector-item-${item.id}`, {
            [`tree-selector-child-${parentId}`]: parentId,
        }), children: renderItem({ input, item, isSearch, isXS: true, disabled: isDisabled }) }));
};

export { MobileItem };
//# sourceMappingURL=MobileItem.js.map
